import { render, staticRenderFns } from "./ArtiklNazivModal.vue?vue&type=template&id=27c86dd4"
import script from "./ArtiklNazivModal.vue?vue&type=script&lang=js"
export * from "./ArtiklNazivModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports